<template>
  <v-card
    outlined
    v-if="!reportData.hidden || isAdmin" 
    :class="{
      'strategio-hidden-item': reportData.hidden
    }"
    :style="[
      {'height': '282px'},
      {'min-width': '313px'},
      {'width': '313px'},
      {'margin': '20px'},
      {'overflow': 'hidden'},
      {'background': '#FFFFFF'},
      {'border': '1px solid rgba(0, 0, 0, 0.05)'},
      {'border-radius': '10px'}
    ]"
    class="d-flex flex-column justify-center align-start report-list-item-card"
    @click="showReport(reportData)"
  >
    <div
      v-if="reportData.imageUrl"
    >
      <img
        class="report-list-item-img"
        :src="getImageUrl(reportData)" alt="report-img"
      >
    </div>
    <div
      v-else
      class="img-circle d-flex justify-center align-center"
    >
      <img
        height="61.89"
        width="61.89"
        :src="getImageUrl(reportData)" alt="report-img"
      >
    </div>

    <div
      v-if="!hideFavoriteIcon"
      style="position: absolute; right: 13px; top: 25px;"
    >
      <div
        v-if="reportData.isFavorite"
      >
        <v-btn icon small
          style="-webkit-text-stroke: 0.3px #2AFE4C"
          color="#2AFE4C"
          @click="setFavorite($event, reportData)"
        >
          <v-icon>ico-icon-star-2</v-icon>
        </v-btn>
      </div>
      <div
        v-else
      >
        <v-btn icon small
          style="-webkit-text-stroke: 0.3px #2AFE4C"
          color="#2AFE4C"
          @click="setFavorite($event, reportData)"
        >
          <v-icon>ico-icon-star</v-icon>
        </v-btn>
      </div>
    </div>

    <div
      class="strategio-report-card-title"
      style="margin-top: 15px;"
    >
      {{reportData.itemName}}
    </div>

    <div
      class="strategio-report-card-subtitle"
      style="margin-top: 10px;"
    >
      {{getItemSubtitle}}
    </div>

    <div style="position: absolute; right: 9px; bottom: 25px;">
      <item-menu :contained-by="containedBy" :item="reportData" v-if="isAdmin || reportData.url2.trim() !== ''" :is-searching="isSearching"></item-menu>          
    </div>
  </v-card>
</template>

<script>
import ItemMenu from '../menus/item-menu.vue'
import reportsStorage from '../../storage/reportsStorage'
import userStorage from '../../storage/userStorage'
import eventBus from '../../utils/eventBus'

export default {
  name: 'report-list-item',
  data () {
    const user = userStorage.getUserInfo()
    const previewImage = reportsStorage.getDefaultPreviewImage()
    const placeholderImage = reportsStorage.getDefaultPlaceholderImage()
    return {
      previewImage: previewImage,
      placeholderImage: placeholderImage,
      userType: user.userType,
      isAdmin: user.userType === 'ADMIN'
    }
  },
  methods: {
    searchByChip (c) {
      this.searchProps.searchCriteria = c
      this.searchItems()
    },
    getImageUrl (report) {
      let reportImage = ''
      const reportImagesFolderPath = 'assets/report-imgs'
      const images = {
        isExcel: `${reportImagesFolderPath}/icon-excel.png`,
        isPowerBI: `${reportImagesFolderPath}/icon-powerbi.png`,
        custom1: `${reportImagesFolderPath}/icon-alt1.png`,
        custom2: `${reportImagesFolderPath}/icon-alt2.png`
      }

      if (!report.imageUrl) { // Siempre y cuando no lleven imageUrl
        if (report.isPowerBI) {
          reportImage = images.isPowerBI
        } else {
          reportImage = images.isExcel
        }
        reportImage = require('@/' + reportImage)
      } else {
        reportImage = report.imageUrl
      }
      return reportImage
    },
    setFavorite (e, report) {
      // if (this.favoritesPage) {
      //   if (report.isFavorite === 0 || report.isFavorite === false) {
      //     return
      //   }
      // } else {
      //   if (report.isFavorite === 1 || report.isFavorite === true) {
      //     return
      //   }
      // }

      e.stopPropagation()

      if (this.userType !== 'DEMO') {
        report.isFavorite = !report.isFavorite
        this.isFavorite = report.isFavorite
        reportsStorage.setFavorite(report.itemID, report.isFavorite, {})
      }
    },
    getChipsData (text) {
      if (text) {
        text = text.replace('$$FOLDER', this.containedBy.itemName)
        return text.split(',').map((item, index) => item.trim())
      }
      return []
    },
    showReport (data) {
      if (data.url1.trim() === '') {
        // descargar si hay url2
        if (data.url2.trim() === '') {
          // descargar reporte y notificar
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización ni de descarga', itsOk: 'warning'})
        } else {
          // Notificar que no hay url de visualizacion ni descarga
          window.open(data.url2, '_blank')
          reportsStorage.registerView(data.itemID, 'DOWNLOAD')
          eventBus.$emit('open-custom-snack-bar', {message: 'No hay URL de visualización. Descargando reporte', itsOk: 'warning'})
        }
      } else {
        let _isFavorite = ''
        if (this.$route.name === 'Favorites') {
          _isFavorite = '/1'
        }
        this.$router.push(`/show-report/${data.itemID}${_isFavorite}`)
      }
    }
  },
  props: {
    reportData: {
      type: Object,
      default () {
        return {}
      }
    },
    favoritesPage: {
      type: Boolean,
      default () {
        return false
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    containedBy: {
      type: Object,
      default () {
        return {}
      }
    },
    searchProps: {
      type: Object,
      default () {
        return { searchCriteria: '' }
      }
    },
    searchItems: {
      type: Function,
      default () {
        return () => { alert('Err func') }
      }
    },
    'hideFavoriteIcon': {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  components: {
    ItemMenu
  },
  computed: {
    getItemSubtitle () {
      let itemFolder = ''
      if (this.reportData.containedBy > 0) {
        itemFolder = reportsStorage.findItemByID(this.reportData.containedBy)
      }

      if (itemFolder === '') {
        return ''
      }
      return itemFolder.itemName
    }
  }
}
</script>
<style>
.report-list-item-card {
  padding: 25px 34px 25px 25px;
}

.strategio-hidden-item {
  opacity: 0.5;
}

.strategio-report-card-title {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
  color: #25235F;
  -webkit-text-stroke: 0.3px #25235F;
}

.strategio-report-card-subtitle {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.5);
}

.img-circle {
  width: 109px;
  height: 109px;
  background: #F4F4F4;
  border-radius: 50% !important;
  cursor: pointer;
}
.report-list-item-img {
  height: 148px;
  max-width: 240px;
}


</style>



// WEBPACK FOOTER //
// src/components/reports/report-list-item.vue